import React, { } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faIdBadge } from '@fortawesome/free-solid-svg-icons'

import { ButtonLink } from '../utils/Button'
import Card from '../utils/Card'

const PremiumMember = () => {
  return (
    <Card className="mt-4">
      <div className="flex items-center mb-4">
        <FontAwesomeIcon icon={faIdBadge} className="mt-2 text-xl md:text-2xl lg:text-3xl" />
        <div className="ml-4 prose prose-lg">
          <h3 className="inline md:hidden lg:inline ">Premium Status: Active!</h3>
          <h3 className="hidden md:inline lg:hidden">Premium Active!</h3>
        </div>
      </div>
      <div>
        <div className="prose prose-lg">
          <p>Thanks for joining our premium service. Your extra benefits have been activated.</p>

          <p>Finding great campsites for you is our passion, and to make that happen we rely on campers like you to support our service. If you love what we do and have found this service valuable, we would be thrilled if you consider giving an extra thank you.</p>
        </div>
        <div className="mt-3">
          <ButtonLink to="/premium/thanks" color="green" className="w-full">
            Say Thanks!
          </ButtonLink>
        </div>
      </div>
    </Card>
  )
}

export default PremiumMember
